import UserTaxiOfficerListRequest, {
  UserTaxiOfficerListRequestStatusCriteria,
  UserTaxiOfficerListRequestOrder,
} from "../../../../api/raily/user/taxi-officer/list/user-taxi-officer-list.request";
import UserStatus from "../../../../types/user-status";
import paginationService from "../../../../utils/pagination/pagination.service";
import UserTaxiOfficerListParams, {
  UserTaxiOfficerListParamsOrder,
} from "./user-taxi-officer-list-params";

const createStatusCriteria = (
  status: UserStatus | undefined,
): UserTaxiOfficerListRequestStatusCriteria => {
  switch (status) {
    case UserStatus.ACTIVE:
      return UserTaxiOfficerListRequestStatusCriteria.ACTIVE;
    case UserStatus.DELETED:
      return UserTaxiOfficerListRequestStatusCriteria.DELETED;
    default:
      return UserTaxiOfficerListRequestStatusCriteria.ALL;
  }
};

const createOrder = (
  status: UserTaxiOfficerListParamsOrder | undefined,
): UserTaxiOfficerListRequestOrder | undefined => {
  switch (status) {
    case UserTaxiOfficerListParamsOrder.FIRST_NAME_ASC:
      return UserTaxiOfficerListRequestOrder.FIRST_NAME_ASC;
    case UserTaxiOfficerListParamsOrder.FIRST_NAME_DESC:
      return UserTaxiOfficerListRequestOrder.FIRST_NAME_DESC;
    case UserTaxiOfficerListParamsOrder.LAST_NAME_ASC:
      return UserTaxiOfficerListRequestOrder.LAST_NAME_ASC;
    case UserTaxiOfficerListParamsOrder.LAST_NAME_DESC:
      return UserTaxiOfficerListRequestOrder.LAST_NAME_DESC;
    case UserTaxiOfficerListParamsOrder.USERNAME_ASC:
      return UserTaxiOfficerListRequestOrder.USERNAME_ASC;
    case UserTaxiOfficerListParamsOrder.USERNAME_DESC:
      return UserTaxiOfficerListRequestOrder.USERNAME_DESC;
    case UserTaxiOfficerListParamsOrder.STATUS_ASC:
      return UserTaxiOfficerListRequestOrder.STATUS_ASC;
    case UserTaxiOfficerListParamsOrder.STATUS_DESC:
      return UserTaxiOfficerListRequestOrder.STATUS_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: UserTaxiOfficerListParams,
): UserTaxiOfficerListRequest => {
  return {
    taxiCorporation: params.taxiCorporation,
    taxiCorporationId: params.taxiCorporationId,
    email: params.email,
    firstName: params.firstName,
    lastName: params.lastName,
    offset: paginationService.calculateOffset(params.page, params.pageSize),
    order: createOrder(params.order),
    statusCriteria: createStatusCriteria(params.status),
    username: params.username,
    creationEnd: params.creationEnd,
    creationStart: params.creationStart,
    limit: params.pageSize,
  };
};

const userTaxiOfficerListParamsFactory = { create };

export default userTaxiOfficerListParamsFactory;
